<!-- No Data Template -->
<ng-template #no_data_template>
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeNoDataText">
          {{ 'global.no_data' | translate }}
        </span>
      </div>
    </div>
  </div>
</ng-template>

<!-- Annotation Template -->
<ng-template #annotation_template
  let-annotation="annotation">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentHandleContainer">
        <button medsurf-design-input-button [id]="'annotation_handle_' + annotation.id"
          [title]="'global.annotation_handle' | translate"
          [class]="FlatModels.TreeDesignModels.TreeDragNodeHandleElement"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_TEXT"
        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentAttributesContainer">
        @if (annotation.type !== FlatModels.AnnotationEntityModels.AnnotationType.enum.FreeForm) {
          <i
          [class]="FlatModels.AnnotationEntityModels.AnnotationTypeIcon[annotation.type]"></i>
        }
        @if (annotation.type === FlatModels.AnnotationEntityModels.AnnotationType.enum.FreeForm) {
          <i
          [class]="FlatModels.AnnotationEntityModels.ShapeIcon[annotation.shape]"></i>
        }
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText">
          {{ slideAuthorFacade.annotationLabelInfo$(annotation.id, translate) | async }}
        </span>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentChipContainer">
        <p-tag
          [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.IMAGE"
          [value]="(annotation.images.length || 0).toString()" />
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentOptionContainer">
        <div class="flex flex-row column-gap-2 w-4rem">
          <div class="flex w-2rem">
            <button medsurf-design-input-button [id]="'annotation_go_to_' + annotation.id"
              [title]="'global.annotation_go_to' | translate"
              [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
              [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.LOCATE"
            (click)="goToAnnotation(annotation)"></button>
          </div>
          <div class="flex w-2rem">
            <button medsurf-design-input-button [id]="'annotation_poi_remove_' + annotation.id"
              [title]="'global.annotation_poi_remove' | translate"
              [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER_SMALL_OUTLINED"
              [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
            (click)="removeAnnotationFromPoi(annotation)"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Content -->
<div class="flex flex-1 flex-column row-gap-2 mb-2">
  <label id="annotations_label"
    class="flex flex-grow-1 flex-row column-gap-2">
    <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ANNOTATIONS"></i>
    <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
      {{ 'global.annotations' | translate }}
    </span>
  </label>
  <div [class]="FlatModels.TreeDesignModels.ItemListContainer">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
      @if (slideAuthorFacade.currentSelectedSlidePoi$ | async; as poi) {
        @if (poi.annotationToPointOfInterest | sortBy_shared:'asc':'order'; as annotationToPointOfInterests) {
            <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
              @if (poi.annotationToPointOfInterest.length === 0) {
                <ng-container *ngTemplateOutlet="no_data_template"></ng-container>
              }
              <div
                [dragula]="getDragulaKey('poi-annotations')"
                [dragulaModel]="annotationToPointOfInterests"
                (dragulaModelChange)="onPoiAnnotationMoved($event)">
                @for (annotationToPointOfInterest of annotationToPointOfInterests; track trackByAnnotationToPointOfInterest($index, annotationToPointOfInterest)) {
                  @if (slideAuthorFacade.annotation$(annotationToPointOfInterest.annotation) | async; as annotation) {
                    @if (!annotation) {
                      @for (i of poi.annotationToPointOfInterest; track i) {
                        <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
                                    class="cursor-wait">
                        </p-skeleton>
                      }
                    }
                    @else {
                        <ng-container *ngTemplateOutlet="annotation_template;context:{annotation}"></ng-container>
                    }
                  }
                }
              </div>
            </div>
        }
      }
    </div>
  </div>

  <!-- Poi Annotation -->
  @if (poiAnnotationForm && poiAnnotationOptionArray && poiAnnotationOptionArray.length > 0) {
    <medsurf-design-form-control-form
      [formGroup]="poiAnnotationForm"
      [class]="'w-full'"
      (onSubmit)="onSubmit()">
      <div class="flex flex-column align-items-center">
        <!-- Annotation -->
        <medsurf-design-form-control-input-dropdown [formField]="false"
          [control]="poiAnnotationForm.controls.id"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY_DROPDOWN"
          [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.SEPARATE_FIRST_ENTRY"
          [class]="'w-full align-self-start'"
          [placeholder]="'global.annotation_link'"
          [options]="poiAnnotationOptionArray"
        (valueChange)="onSubmit()"></medsurf-design-form-control-input-dropdown>
      </div>
    </medsurf-design-form-control-form>
  }
</div>
